import { CookieSetOptions } from 'universal-cookie';
import { AnonymousUser } from '../../contexts/anonUser';

import { Session } from '../../contexts/session';

export enum CookieNames {
    Session = 'sess',
    AnonymousUser = 'anonUser',
    Notifications = 'notif',
}

export type CookiesType = {
    [CookieNames.Session]?: Session;
    [CookieNames.AnonymousUser]?: AnonymousUser;
    [CookieNames.Notifications]?: number;
};

// From useCookies hook (react-cookie library)
export type ReactCookieType = [
    CookiesType,
    (
        name: CookieNames,
        value: any,
        options?: CookieSetOptions | undefined,
    ) => void,
    (name: CookieNames, options?: CookieSetOptions | undefined) => void,
];

export enum CookieNotificationWeight {
    Intro = 1,
}
